import $ from 'jquery';
import whatInput from 'what-input';
import app from './app.first';
import slick from 'slick-carousel';
import select2 from '../vendor/select2/select2';
import { each } from 'lodash';

//Loads in all pages and components created by us
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('./components/', true, /\.js$/));

window.$ = $;

//import Foundation from 'foundation-sites';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';

// init foundation
$(document).ready(function () {
    // Custom validation patterns
    Foundation.Abide.defaults.patterns['cellnumber'] = /^(\d\-?){10,}$/;
    Foundation.Abide.defaults.patterns['alpha'] = /^[a-zA-Z -]+$/;
    Foundation.Abide.defaults.patterns['idnumber'] = /^(\d){13}$/;
    Foundation.Abide.defaults.patterns['postalcode'] = /^(\d){4}$/;
    Foundation.Abide.defaults.patterns['comma_separated_list'] = /^[0-9\w[,\s0-9\w]*]?$/;

    // Custom validations validators
    Foundation.Abide.defaults.validators['id_validator'] = function($el, required, parent) {
        let monthMaxDay = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        //required validation
        if ($el.val().length < 1 && required) {
            $('#' + $el.attr('data-error')).text('Required');
            return false;
        }

        //integer validation
        else if (isNaN($el.val())) {
            $('#' + $el.attr('data-error')).text('Please enter a 13 digit valid ID number');
            return false;
        }

        //length validation
        else if (($el.val().length < 13 && $el.val().length > 0) || $el.val().length > 13) {
            $('#' + $el.attr('data-error')).text('Please enter a 13 digit valid ID number');
            return false;
        }

        //month validation
        else if (parseInt($el.val().substring(2, 4)) > 12) {
            $('#' + $el.attr('data-error')).text('ID should contain a valid date of birth');
            return false;
        }

        //day validation
        else if (parseInt($el.val().substring(2, 4)) < 13 && parseInt($el.val().substring(4, 6)) > monthMaxDay[parseInt($el.val().substring(2, 4)) - 1]) {
            $('#' + $el.attr('data-error')).text('ID should contain a valid date of birth');
            return false;
        }

        //gender validation
        else if (($el.attr('data-title') == "mr" && parseInt($el.val().substring(6, 10)) < 5000) || ($el.attr('title') == "Ms" && parseInt($el.val().substring(6, 10)) > 4999)) {
            $('#' + $el.attr('data-error')).text('Invalid gender');
            return false;
        }

        //citizenship
        else if (parseInt($el.val().substring(10, 11)) > 1) {
            $('#' + $el.attr('data-error')).text('Invalid citizenship');
            return false;
        }

        //always 8
        else if (parseInt($el.val().substring(11, 12)) != 8) {
            $('#' + $el.attr('data-error')).text('Invalid SA ID number');
            return false;
        }

        else {
            let validateNumber = parseInt(parseInt($el.val()) / 10), isEvenDigit = true, summation = 0;
            while (validateNumber > 0) {
                let lastDigit = validateNumber % 10;
                if (isEvenDigit) {
                    lastDigit *= 2;
                    if (lastDigit > 9) {
                        lastDigit -= 9;
                    }
                }
                summation += lastDigit;
                isEvenDigit = !isEvenDigit;
                validateNumber = parseInt(validateNumber / 10);
            }
            $('#' + $el.attr('data-error')).text(parseInt($el.val().substring(12)) == (summation * 9) % 10 ? '' : 'Invalid last digit');
            return parseInt($el.val().substring(12)) == (summation * 9) % 10;
        }
    }
    Foundation.Abide.defaults.validators['end_date'] = function($el, required, parent) {
        let startDate = new Date($(`#${$el.attr('data-start-date')}`).val());
        let endDate = new Date(`${$el.val()}`);
        return endDate > startDate || ($el.val() == "" && !required);
    }

    $('form').on('submit', () => {
        document.querySelectorAll('input[pattern=cellnumber]').forEach(node => {
            node.value = node.value.replace(/-/g, '');
        })
    })

    $(document).foundation();
});

// scroll to first invalid field
$(window).on('load', function() {
    // $('form').on('forminvalid.zf.abide', function() {
    //     let invalidFields = $(this).find('.is-invalid-input');
    //     if (invalidFields.length > 0) {
    //         $('html, body').animate({
    //             scrollTop: $(".is-invalid-input").offset().top - 25
    //         }, 4000);
    //     }
    // });
});

// attach our app class to jquery
app.attachToJquery($);

// initialize our classes into dom
$(document).initialize();

var mobileInputs = 1;

$(document).ready(function () {
    $(".hamburger").click(function () {
        $(this).toggleClass("is-active");
        $(".mobile-menu").toggleClass("is-active");
    });

    $(window).resize(function () {
        $(".mobile-menu").removeClass("is-active");
        $(".hamburger").removeClass("is-active");
    });

    // Patch for a Bug in v6.3.1
    $(window).on('changed.zf.mediaquery', function () {
        $('.is-dropdown-submenu.invisible').removeClass('invisible');
    });

    // Close alert box
    $('.alert-close').click(function() {
        $(this).parent().hide();
    });
});

app.initSelect2 = () => {
    let $elements = $("select.select2:not(.select2-hidden-accessible)");

    each($elements, el => {
        let $el = $(el);
        $el.select2({
            width: '100%',
            closeOnSelect: !el.multiple,
            placeholder: $el.data('placeholder'),
            tags: Boolean($el.data('tags')),
            limit: 1000
        });
    });
}
app.initSelect2();